import React from 'react';

const LikeIcon = ({ className = null }) => (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M11.1663 1.09853C10.4579 0.39011 9.51007 0 8.49715 0C7.6251 0 6.80138 0.289215 6.13703 0.821659C5.46314 0.289215 4.6384 0 3.77487 0C2.75726 0 1.80692 0.390277 1.09853 1.09853C0.39011 1.8068 0 2.75479 0 3.76754C0 4.78044 0.39011 5.72829 1.09853 6.43654L5.81346 11.1515C5.89938 11.2376 6.01219 11.2806 6.125 11.2806C6.23752 11.2806 6.35002 11.2377 6.43611 11.152L11.1548 6.44769C11.8612 5.72549 12.25 4.77633 12.25 3.77489C12.25 2.76419 11.8664 1.81503 11.1663 1.09853Z" fill={className ? 'currentColor' : '#FF6161'} />
  </svg>
);

export default LikeIcon;
